// import React from "@types/react";

import SectionHandler from "./SectionHandler";
import React from "react";
import UploadSection from "./UploadSection";

import {ActionPageCreate, StatePageCreate} from "../PageCreate";


class FirstSection extends SectionHandler {

    constructor(state: StatePageCreate, dispatch: React.Dispatch<ActionPageCreate>) {
        super(state, dispatch);
    }

    nextHandler() {
        return this.state.toggles.has('generated') ? new UploadSection(this.state, this.dispatch) : null;
    }

    handle() {
        // console.log('handle', this.props.level);
        return <>
            <div className="row my-4">
                <div className="md-12">
                    <h1 className={"text-center"}>
                        {this.state.name ? `${this.state.name} Loves Wang` : "I Love Wang"}
                    </h1>
                </div>
            </div>
            { this.state.imagerSample.hasErrors() && <>
                <div className="row my-2">
                    <div className="md-12 text-center alert alert-danger">
                        {this.state.imagerSample.errors().map((error) => {
                            return <>{error}<br/></>
                        })}
                    </div>
                </div>
            </>}
            <div className="row mt-2">
                <div className="md-12 text-center">
                    <button className={"btn btn-primary btn-lg"} disabled={this.state.imagerSample.isInProgress()}
                            onClick={() => this.generate()}>
                        {this.state.toggles.has('generated') ? "Re-Generate Fan Page" : "Generate Fan Page"}
                    </button>
                </div>
            </div>
        </>;
    }
}

export default FirstSection;
